import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CardContainerComponent } from './card-container.component';
import { AngularMaterialModule } from '@morningstar/shared/ui-kit/angular-material';
import { CardModule } from '@morningstar/shared/ui-kit/card';
import { HelpVideoIconModule } from '@morningstar/wsg/ui-kit/help-video-icon';

@NgModule({
  declarations: [
    CardContainerComponent
  ],
  imports: [
    CommonModule,
    AngularMaterialModule,
    CardModule,
    HelpVideoIconModule
  ],
  exports: [
    CardContainerComponent
  ]
})
export class CardContainerModule { }
